/* eslint-disable camelcase */
/* eslint-disable no-return-await */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import * as React from 'react';
import api from '../../../../services/api';
import Button from '../../../Button';
import ModalTicket from '../../../ModalTicket';
import Select from '../Select';
import { useToast } from '../../../../hooks/toast';
import { useLoader } from '../../../../hooks/loader';

const Content: React.FC<any> = ({ handleClose }) => {
  // const [title, setTitle] = React.useState('');
  const [line, setLine] = React.useState<any>(undefined);
  const [ticket, setTicket ] = React.useState<any>(undefined);

  const { addToast } = useToast();
  const { changeLoader } = useLoader();

  const getList = React.useCallback(async () => {
    try {
      const { data } = await api.get(`/core/qr-code/lines/`);
      console.log(data);
    } catch (e) {
      console.log(e);
    }
  }, []);
  React.useEffect(() => {
    getList();
  }, []);
  console.log(ticket);

  return (
    <>
      <div
        style={{
          height: 500,
          width: '100%',
        }}
      >
        {/* <Input
          placeholder="Linhas"
          label="Linhas"
          value={title}
          onChange={(e: any) => setTitle(e.target.value)}
        /> */}
        <Select
          placeholder="Linhas"
          label="Linhas"
          getOptionLabel={label => {
            return label.id.linha.linCodLinhaExterno === '6000' || 
            label.id.linha.linCodLinhaExterno === '6001' ||
            label.id.linha.linCodLinhaExterno === '2000' ||
            label.id.linha.linCodLinhaExterno === '2001' ||
            label.id.linha.linCodLinhaExterno === '2002' ||
            label.id.linha.linCodLinhaExterno === '7000' ||
            label.id.linha.linCodLinhaExterno === '7001' ||
            label.id.linha.linCodLinhaExterno === '4001' ||
            label.id.linha.linCodLinhaExterno === '4002' ||
            label.id.linha.linCodLinhaExterno === '4004' ||
            label.id.linha.linCodLinhaExterno === '1000' ||
            label.id.linha.linCodLinhaExterno === '1001' ||
            label.id.linha.linCodLinhaExterno === '1002' ||
            label.id.linha.linCodLinhaExterno === '3000' ||
            label.id.linha.linCodLinhaExterno === '3001' ?
            label.id.linha.linNomeLinha :
            `${label.id.linha.linCodLinhaExterno  } - ${  label.id.linha.linNomeLinha}`;
          }}
          getOptionValue={value => {
            return value.id.linha.linCodLinhaExterno || value.id.linha.linNomeLinha;
          }}
          onChange={(e: any) => setLine(e)}
        />
        {line && (
          <div style={{ marginTop: 20 }}>
            <div><b>Valor da tarifa:</b> R${formatCurrency(line?.tarifa?.valorTarifa)}</div>
          </div>
        )}
        {line && (
          <Button
            style={{
              marginTop: '30px',
            }}
            color="orange"
            padding=""
            rounded
            className="button-generate-ticket-qrcode"
            type="button"
            onClick={async () => {
              try {
                const response = await api.post('/ticketing/qr-code/create-ticket-by-value/', {
                  line_main_code: line?.id?.linha?.id,
                  value: line?.tarifa?.valorTarifa
                })
                setTicket({
                  code: response?.data?.codigoQRCode,
                  line: response?.data?.linha,
                  value: response?.data?.valor,
                  image: response?.data?.imagemBase64,
                })
                
              }catch (err: any) {
                changeLoader(false);
                const { ...error } = err;
                console.log(error);
                if (error?.response?.data?.detail === "Cartão transfácil está bloqueado.") {
                  addToast({
                    type: 'error',
                    title: `${error?.response?.data?.detail}`,
                    description:
                      error?.response?.data?.detail &&
                      `${error?.response?.data?.detail}`,
                  });
                } else {
                  addToast({
                    type: 'error',
                    title: `${error?.response?.data?.message}`,
                    description:
                      error?.response?.data?.sub_message &&
                      `${error?.response?.data?.sub_message}`,
                  });
                }
                
              }
              
              // handleClose()
            }}
          >
            GERAR
          </Button>
        )}
      </div>
      {ticket && (
        <ModalTicket
          code={ticket?.code}
          line={ticket?.line}
          value={ticket?.value}
          closeModal={() => setTicket(undefined)}
          image={ticket?.image}
        />
      )}
    </>
  );
};

export { Content };
